import Vue from 'vue'
import Vuex from 'vuex'

import invoice from './invoice'
import invoiceDetail from './invoice-detail'
import invoiceView from './invoice-view'
import contacts from './contacts'
import users from './users'
import catalog from './catalog'
import invoices from './invoices'
import selectors from './selectors'
import me from './me'
import multicompany from './multicompany'
import errors from './errors'
import config from './config'
import notifications from './notifications'
import charts from './charts'
import app from './app'
import financeables from './financeables'
import debug from './debug'
import requestFactoring from './requestFactoring/requestFactoring'
import sii from './sii'
import verifactu from './verifactu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    charts,
    invoice,
    invoiceDetail,
    invoiceView,
    contacts,
    users,
    catalog,
    invoices,
    selectors,
    config,
    me,
    multicompany,
    financeables,
    debug,
    notifications,
    errors,
    requestFactoring,
    app,
    sii,
    verifactu
  }
})
